import { CustomerPrivacyApiError } from '../../customerPrivacyApi'

export const PRIVACY_SESSION_INVALID_ERROR = 'Sessione cliente non valida'

export const toPrivacyErrorMessage = (error: unknown): string => {
  if (error instanceof CustomerPrivacyApiError) {
    return error.message
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message
  }
  return 'Errore gestione privacy account'
}
